import React from 'react';
import { Hero } from '../components/site/Hero';
import { Positioning } from '../components/site/Positioning';
import { WhyNotATS } from '../components/site/WhyNotATS';
import { Scenarios } from '../components/site/Scenarios';
import { HowItWorks } from '../components/site/HowItWorks';
import { SessionTrace } from '../components/site/SessionTrace';
import { DecisionRecord } from '../components/site/DecisionRecord';
import { Pipeline } from '../components/site/Pipeline';
import { Library } from '../components/site/Library';
import { Candidates } from '../components/site/Candidates';
import { Compliance } from '../components/site/Compliance';
import { Evidence } from '../components/site/Evidence';
import { Contact } from '../components/site/Contact';
export function Home() {
  return <>
      <Hero data-id="element-474" data-mp="3kvtonnr76826" />
      <Positioning data-id="element-475" data-mp="3ku8rrrheud15" />
      <WhyNotATS data-id="element-476" data-mp="3kuqun6ykvpi1" />
      <Scenarios data-id="element-477" data-mp="3kxd1f4dna0z7" />
      <HowItWorks data-id="element-478" data-mp="3owvl5wtqc60g" />
      <SessionTrace data-id="element-479" data-mp="3owce5b5mb217" />
      <DecisionRecord data-id="element-480" data-mp="3ovu7rlp8r7fk" />
      <Pipeline data-id="element-481" data-mp="3ov2g2lyrltuk" />
      <Library data-id="element-482" data-mp="3oyq97k0ase8r" />
      <Candidates data-id="element-483" data-mp="30wjcmpo0ou4v" />
      <Compliance data-id="element-484" data-mp="30x1go8gx8cnc" />
      <Evidence data-id="element-485" data-mp="30vgnona991rl" />
      <Contact data-id="element-486" data-mp="30w04u1s2zm4k" />
    </>;
}